// extracted by mini-css-extract-plugin
export default {"snackbar":"snackbar_snackbar__zh7T2"};